var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulesView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H13V16H8V14ZM11.4 10H8V12H14.7C13.4 11.7 12.2 11 11.4 10ZM4 16H6V14H4V16ZM6 10H4V12H6V10ZM18 12.5V18H2V8H10.2C9.9 7.3 9.8 6.6 9.8 5.8C9.8 4.4 10.3 3.1 11.1 2H7V0H5V2H1C0.4 2 0 2.4 0 3V19C0 19.6 0.4 20 1 20H19C19.6 20 20 19.6 20 19V11.5C19.4 11.9 18.7 12.3 18 12.5Z",
    fill: "#525256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1998 0.400024C19.1998 0.400024 21.5998 2.80002 21.5998 5.80002C21.5998 8.80002 19.1998 11.2 16.1998 11.2C13.1998 11.2 10.7998 8.80002 10.7998 5.80002C10.7998 2.80002 13.1998 0.400024 16.1998 0.400024ZM16.1998 10.2C18.5998 10.2 20.4998 8.30002 20.4998 5.90002C20.4998 3.50002 18.5998 1.60002 16.1998 1.60002C13.7998 1.60002 11.8998 3.50002 11.8998 5.90002C11.8998 8.30002 13.7998 10.2 16.1998 10.2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1465 11.8536L19.1465 9.85356L19.8536 9.14645L21.8536 11.1465L21.1465 11.8536Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesView);
export default __webpack_public_path__ + "static/media/Schedules_View.6556171dae167bdd10d72382cfde72c7.svg";
export { ForwardRef as ReactComponent };